// Re-export from ThemeContext for backward compatibility
export { useTheme } from "./ThemeContext";
